module.exports = __webpack_public_path__ + "img/74.c5192d2d.jpg";